module.exports = __webpack_public_path__ + "img/laptop_mac.2646aabb.svg";